import request from "./../utils/request";

export function updateChatStamp(data) {
    return request({
        url: "/team/update-chat-stamp",
        method: "post",
        data: data,
    });
}

export function getChatsLastMessages(data) {
    return request({
        url: "/team/get-last-messages-chats",
        method: "post",
        data: data,
    });
}

export function chatNameUpdate(data) {
    return request({
        url: "/team/chat-name-update",
        method: "post",
        data: data,
    });
}

export function chatProfilePhotoUpdate(data) {
    return request({
        url: "/team/chat-profile-photo-update",
        method: "post",
        data: data,
    });
}

export function chatProfilePhotoDelete(data) {
    return request({
        url: "/team/chat-profile-photo-delete",
        method: "post",
        data: data,
    });
}

export function leaveChatGroup(data) {
    return request({
        url: "/team/leave-chat-group",
        method: "post",
        data: data,
    });
}

export function getChatMedia(chatId) {
    return request({
        url: `/team/get-media-by-chat-id/${chatId}`,
        method: "get",
    });
}

export function extractLinksFromChat(chatId) {
    return request({
        url: `/team/get-urls-by-chat-id/${chatId}`,
        method: "get",
    });
}

export function deleteGrup(data) {
    return request({
        url: "/team/deletePrivateGroupThreadConversation",
        method: "post",
        data: data,
    });
}
